import cls from '@utils/css-select';
import { toast } from 'components/dialogs';
import Section from 'components/section';
import { COUNTRYCODE_LANG_MAP, LANG } from 'constants/country';
import { useTranslation } from 'hooks/use-translation';
import React, { useEffect, useLayoutEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { ConnectState } from 'states/connect';
import styles from './styles.scss';

const cx = cls(styles);

/**
 * twitter 埋点
 */
function injectTwitterHTML() {
	window.twttr = null //兼容变量undefined报错问题
	const loadJS = document.createElement('script');
	loadJS.src = '//platform.twitter.com/oct.js';
	loadJS.defer = true;

	const runJS = document.createElement('script');
	runJS.innerHTML = `twttr&&twttr.conversion.trackPid('o6l4d', { tw_sale_amount: 0, tw_order_quantity: 0 });`;
	loadJS.defer = true;

	const noScript = document.createElement('noscript');
	noScript.innerHTML = `<img height="1" width="1" style="display:none;" alt="" src="https://analytics.twitter.com/i/adsct?txn_id=o6l4d&p_id=Twitter&tw_sale_amount=0&tw_order_quantity=0" />\n		<img height="1" width="1" style="display:none;" alt="" src="//t.co/i/adsct?txn_id=o6l4d&p_id=Twitter&tw_sale_amount=0&tw_order_quantity=0" />`;

	try {
		document.documentElement.append(noScript, loadJS, runJS);
	} catch (error) {
		console.log(error);
	}
}

function injectAWINScript() {
	const oldScript = document.getElementById('awinJS')
	if (oldScript) document.body.removeChild(oldScript)

	const loadJS = document.createElement('script');
	loadJS.src = 'https://www.dwin1.com/25266.js';
	loadJS.defer = true

	document.body.append(loadJS)
}

/**
 *用户隐私协议
 *
 * @export
 */
export default function ApplySuccess() {
	const inputRef = useRef<HTMLInputElement | null>(null);
	const { transData, local: lang } = useTranslation('success');
	const successWrapRef = useRef(document.createElement('div'))
	const onCopy = () => {
		if (!inputRef.current) return;
		inputRef.current.select();
		const copied = document.execCommand('copy');
		if (copied) toast({ message: transData.copied });
	};

	useEffect(() => {
		const app = document.getElementById('app')
		if (app) app.scrollTo(0, 0)
		injectTwitterHTML();
	}, []);

	useEffect(() => {
		if (window.AWIN) injectAWINScript()
	}, [])

	useLayoutEffect(() => {
		if (!successWrapRef.current) return
		const outerWrap = successWrapRef.current?.parentElement
		outerWrap && (outerWrap.style.minHeight = 'auto')
	}, [successWrapRef.current])

	if (lang === COUNTRYCODE_LANG_MAP.EN || !!LANG.find(item => lang.includes(item.code))) {
		return (
			<>
				<div className={cx('success-wrap', 'en')} ref={successWrapRef}>
					<Section className={cx('container')}>
						<img
							loading="lazy"
							className={cx('icon')}
							src="https://web-data.zmlearn.com/image/iWaq2Jr7dwJreoDoufXE9j/result_sure.png"
							alt="air-class"
						/>
						<h4>{transData.title}</h4>
						<p>{transData.title1}</p>
						{/* <div className={cx('concat-en')}>
							<span>{transData.title2}</span>
							<img loading="lazy" src="https://web-data.zmlearn.com/image/mCXnvs3UddieabmWzpTj8H/qrcode.png" alt="air-class-qrcode" />
						</div> */}
						{lang === 'en-AU' ? (
							<p className={cx('fb-guide-follow')}>
								<img src="https://web-data.zmlearn.com/image/vi3qSHQcjSy1SAnUsRraZt/2021_Facebook_icon.svg.png" alt="" />
								<a href="https://www.facebook.com/airclassasia">{transData.title3}&gt;&gt;&gt;</a>
							</p>
						) : (
							''
						)}
					</Section>
				</div>
			</>
		);
	}
	return (
		<div className={cx('success-wrap')}>
			<Section className={cx('container')}>
				<img
					loading="lazy"
					className={cx('icon')}
					src="https://web-data.zmlearn.com/image/iWaq2Jr7dwJreoDoufXE9j/result_sure.png"
					alt="air-class"
				/>
				{
					// 六国中的英国
					lang === COUNTRYCODE_LANG_MAP.UK ? (
						<>
							<h4>
								{transData.title4}
							</h4>
							<div className={cx('concat', 'en-GB')}>
								<div className={cx('title')}>{transData.title5}</div>
								<div className={cx('copy')}>
									<label>+44</label>
									<span>
										7429241233
										<input type="text" ref={inputRef} readOnly value="7429241233" />
									</span>
									<button onClick={onCopy}>{transData.copy}</button>
								</div>
							</div>
							<div className={cx('sub-concat')}>
								{transData.title6}
							</div>
						</>
					) : (
						// 六国其他五国
						<h4>{transData.title7}</h4>
					)
				}
			</Section>
		</div>
	);
}
